import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-screen w-full items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=cinematic%20anime%20world%20of%20a%20night%20city%20with%20glowing%20vermillion%20torii%20gates%20and%20neon%20lanterns%20under%20a%20starry%20sky%2C%20floating%20sakura%20petals%2C%20deep%20ink%20blue%20night%20with%20warm%20crimson%20and%20amber%20glow%2C%20epic%20atmospheric%20concept%20art&width=1600&height=1000&seq=hero-main&orientation=landscape)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pt-24 pb-16 md:px-6 md:pt-28">
        <div className="anim-fade-up max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3 py-1 text-xs text-primary-200">
            <i className="ri-flashlight-line" />
            2026 夏季新番持续更新中
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-50 md:text-6xl">
            漫镜 · 追番的一站式灯塔
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
            新番情报、高分榜单、深度评测与主题分类，聚合优质动漫资讯。
            帮你在海量作品中快速定位心仪之选，把时间留给真正值得追的好番。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#new"
              className="rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              开始选番
            </a>
            <a
              href="#top"
              className="rounded-md border border-background-600 bg-background-950/50 px-6 py-3 text-center text-sm text-foreground-200 whitespace-nowrap transition-colors hover:border-primary-400 hover:text-primary-300"
            >
              查看高分榜
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-800/60 bg-background-900/60 px-5 py-4 backdrop-blur-sm"
            >
              <p className="font-heading text-3xl text-primary-300 md:text-4xl">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-400 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}